import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'components/Core/Accordion';
import ContentfulFAQAccordion from './ContentfulFAQAccordion';

const ContentfulAccordion = (props) => {
  const isFAQ = props?.components?.every((c) => c?.__typename === 'ContentfulFaq');

  return isFAQ ? <ContentfulFAQAccordion {...props} /> : <Accordion {...props} />;
};

ContentfulAccordion.defaultProps = {
  border: true,
};

ContentfulAccordion.propTypes = {
  border: PropTypes.bool,
  background: PropTypes.object,
  title: PropTypes.string,
  subhead: PropTypes.object,
  components: PropTypes.array,
};

export default ContentfulAccordion;
